import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react-lite';

import { TextArea } from 'spindl-shared-components';

import styles from './ModalLongTextContent.module.scss';
import usePresenter from './ModalLongTextContent.presenter';
import getProps from './ModalLongTextContent.props';
import { ModalLongTextContentCombinedProps } from './types';


// MANUAL OVERRIDE - converted to observer Component
const ModalLongTextContent: React.FC<ModalLongTextContentCombinedProps> = observer((props) => {
  const {
    state,
    className,
    classes,
    textArea,
    textAreaRef, // MANUAL OVERRIDE
    handleBlur, // MANUAL OVERRIDE
    handleClick, // MANUAL OVERRIDE
  } = usePresenter(props);

  const variantName = `${state}`;
  const internalProps = getProps(variantName);
  const currentStyle = styles[`modalLongTextContent${variantName}`];

  let componentView;

  switch (variantName) {
    case 'Default':
    case 'Error':
    case 'Expanded':
    case 'FirstSelect':
    case 'FirstSelectExpanded': {
      componentView = (
        <div
          className={cx(currentStyle, className)}
          onBlur={handleBlur} // MANUAL OVERRIDE
          onClick={handleClick} // MANUAL OVERRIDE
          tabIndex={0} // MANUAL OVERRIDE
        >
          <TextArea
            className={cx(styles.textArea, classes?.textArea)}
            ref={textAreaRef} // MANUAL OVERRIDE
            tabIndex={-1} // MANUAL OVERRIDE
            {...internalProps.textArea}
            {...textArea}
          />
        </div>
      );
      break;
    }
    default:
      componentView = <div>�</div>;
      break;
  }

  return componentView;
}); // MANUAL OVERRIDE

export default ModalLongTextContent;
